import Background from './Background';
import Device from './Device';
export default { Device, Background } 
